<template>
  <div>
    <circle-loader ref="circleLoader" />
    <b-card class="md-3" id="main" v-if="!submitted">
      <p>Agregar nuevo rol</p>
      <div>
        <b-form @submit="saveRole">
          <div class="groupBox">
            <b-row>
              <!--b-row principal contiene todo el componente-->
              <b-col>
                <!--b-col principal contiene todo el componente-->
                <b-row id="firstRow">
                  <!--b-row para el input del alias y el switch de la tabla-->
                  <b-col>
                    <!--b-col para el input del alias-->
                    <!--INPUT DEL ALIAS-->
                    <b-form-group
                      label-size="sm"
                      label="Alias del rol *"
                      label-for="alias"
                    >
                      <b-form-input
                        id="alias"
                        name="alias"
                        size="sm"
                        placeholder="..."
                        autocomplete="off"
                        v-model="role.alias"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <!--b-col para el switch de la tabla-->
                    <!--SWITCH DE LA TABLA-->
                    <b-form-group>
                      <div class="form-check form-switch" id="seccionesSwitch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="flexSwitchCheckDefault1"
                          v-model="showTable"
                          @click="resetTable"
                        />
                        <label
                          class="form-check-label"
                          for="flexSwitchCheckDefault1"
                          >Permisos por secciones</label
                        >
                      </div>
                    </b-form-group>
                  </b-col> 
                </b-row>
                <b-row id="secondRow">
                  <!--b-row para las anotaciones-->
                  <!--ANOTACION - ALIAS REQUERIDO-->
                  <small> * Rellene este campo </small>
                
                  <!--ANOTACION - EXPLICACIÓN DE TABLA POR SECCIÓN-->
                  <small v-if="showTable" id="secondNote">
                    Puede conceder permisos rápidamente a su nuevo rol eligiendo
                    las acciones permitidas por sección
                  </small>
                </b-row>
                <b-row>
                  <!--b-row para el card de la tabla-->
                  <!--CARD TABLA-->
                  <b-card class="md-3" v-if="showTable" id="sections">
                    <p>Tabla de secciones</p>

                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="uncheckAll"
                    >
                      <i class="far fa-square"></i>
                      Desmarcar todo
                    </button>

                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="checkAll"
                    >
                      <i class="far fa-check-square"></i>
                      Marcar todo
                    </button>

                    <table>
                      <tr>
                        <th>SECCIÓN</th>
                        <th>VER</th>
                        <th>CREAR</th>
                        <th>MODIFICAR</th>
                        <th>ELIMINAR</th>
                      </tr>

                      <tr
                        v-for="(sectionItem, index) in sectionList"
                        v-bind:key="index"
                        v-bind:value="sectionItem"
                      >
                        <td>{{ sectionItem }}</td>
                        <td>
                          <input
                            type="checkbox"
                            v-model="sections[sectionItem].see"
                            class="check"
                            @click="manageChecking"
                            v-text="sectionItem+'_see'"
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            v-model="sections[sectionItem].create"
                            class="check"
                            @click="manageChecking"
                            v-text="sectionItem+'_create'"
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            v-model="sections[sectionItem].update"
                            class="check"
                            @click="manageChecking"
                            v-text="sectionItem+'_update'"
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            v-model="sections[sectionItem].delete"
                            class="check"
                            @click="manageChecking"
                            v-text="sectionItem+'_delete'"
                          />
                        </td>
                      </tr>
                    </table>               
                  </b-card>
                </b-row>
                <b-row>
                  <!--b-row para el card de la nota-->
                  <!--CARD NOTA-->
                  <b-card class="md-3" v-if="showTable" id="annotation">
                    <p>Nota<span>:</span></p>
                    <small>
                      Los permisos de administración especiales no se pueden
                      conceder al crear un rol
                    </small>
                  </b-card>
                </b-row>
                <b-row>
                  <!--b-row para el boton de guardar-->
                  <!--BOTON DE GUARDAR-->
                  <button type="submit" class="btn btn-success" id="savebtn">
                    <i class="fas fa-edit"></i>
                    Guardar rol
                  </button>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>
<script>
import CircleLoader from "@/components/common/CircleLoader";
import UserService from "@/services/UserService";

export default {
  name: "add-role",
  components: {
    "circle-loader": CircleLoader,
  },
  data() {
    return {
      role: {
        alias: "",
        actions: [],
      },
      sectionList: [],
      sections: {},
      actions: {},
      keyWordList: [],
      showTable: true,
      submitted: false,
    };
  },
  mounted() {
    UserService.getSections()
      .then((response) => {
        this.sectionList = response.data;
        response.data.forEach((section) => {
          switch (section) {
            case "Perfil":
              this.sections[section] = {
                see: true,
                create: true,
                update: true,
                delete: true,
              };
              break;
            case "Usuarios":
              this.sections[section] = {
                see: false,
                create: false,
                update: false,
                delete: false,
              };
              break;
            default:
              this.sections[section] = {
                see: true,
                create: false,
                update: false,
                delete: false,
              };
              break;
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
    UserService.getAllActions()
    .then((response) => {
        this.actions = response.data;
        this.keyWordList = Object.keys(this.actions);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    saveRole(e) {
      e.preventDefault();
      let keywordArray = [];
      if (!this.role.alias) {
        document.getElementById("alias").focus();
      }
      if (this.showTable) {
        keywordArray = this.getKeywordArray();
      }
      let newRole = {
        alias: this.role.alias,
        sections: keywordArray,
      };
      UserService.createRole(newRole)
        .then((response) => {
          this.submitted = true;
          this.$emit('refreshList')
          this.$refs.circleLoader.showLoading("Registrando rol ...");
          setTimeout(() => {
            //Checkar cabeceras e vuelta para cargar la X o el tick
            if (
              !response.data.code ||
              response.data.code == 3000 ||
              response.status == 202
            ) {
              this.$refs.circleLoader.showEndError(response.data.message);
            } else {
              this.$refs.circleLoader.showEndSuccess(response.data.message);
            }
            //Temporizador antes de mostrar de nuevo el formulario
            setTimeout(() => {
              this.submitted = false;
              this.$refs.circleLoader.reset();

              //Emit event to notify parent to notify the other component
              //this.$emit("rowadded");
              //Remove form data
              this.resetValues();
            }, 1500);
          }, 2500);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetValues() {
      this.showTable = false;
      this.role.alias = "";
      this.role.actions = [];
      this.resetTable();
    },
    resetTable(){
      this.sectionList.forEach((section) => {
        switch (section) {
          case "Perfil":
            this.sections[section] = {
              see: true,
              create: true,
              update: true,
              delete: true,
            };
            break;
          case "Usuarios":
            this.sections[section] = {
              see: false,
              create: false,
              update: false,
              delete: false,
            };
            break;
          default:
            this.sections[section] = {
              see: true,
              create: false,
              update: false,
              delete: false,
            };
            break;
        }
      });
    },
    manageChecking(e) {
      let clicked = e.target.textContent.split('_');
      if(clicked[0]=="Perfil" || clicked[0]=="Usuarios"){
        let checks = document.getElementsByClassName("check");
        for(let i=0;i<checks.length;i++){
          let siblingTextContent = checks[i].textContent.split('_');
          if(siblingTextContent[0]==clicked[0] && siblingTextContent[1]!=clicked[1]){
            checks[i].checked = !checks[i].checked;
          }
        }
      }
    },
    uncheckAll() {
      this.applyCheckToAll(false);
    },
    checkAll() {
      this.applyCheckToAll(true);
    },
    applyCheckToAll(mode){
      let checks = document.getElementsByClassName("check");
      for(let i=0;i<checks.length;i++){
        checks[i].checked = mode;
      }
      this.updateSections(mode);
    },
    updateSections(mode){
      this.sectionList.forEach((section) => {
        this.sections[section].see = mode;
        this.sections[section].create = mode;
        this.sections[section].update = mode;
        this.sections[section].delete = mode;
      });
    },
    getKeywordArray() {
      let completeKeywordArray = [];
      this.sectionList.forEach(section=>{
        let sect = this.sections[section];
        this.keyWordList.forEach(keyword =>{
          let action = this.actions[keyword];
          if(action.section==section){
            let actionGroup = keyword.split('_')[1];
            switch(actionGroup){
              case "VER":
                if(sect.see){
                  completeKeywordArray.push(keyword)
                }
              break;
              case "CREAR":
                if(sect.create){
                  completeKeywordArray.push(keyword)
                }
              break;
              case "ACTUALIZAR":
                if(sect.update){
                  completeKeywordArray.push(keyword)
                }
              break;
              case "ELIMINAR":
                if(sect.delete){
                  completeKeywordArray.push(keyword)
                }
              break;
              case "SELF":
                if(sect.see){
                  completeKeywordArray.push(keyword)
                }
              break;
              case "ADMIN":
                if(sect.see){
                  completeKeywordArray.push(keyword)
                }
              break;
            }
          }
        })
      });
      return completeKeywordArray;
    },
  },
};
</script>

<style scoped>
#main {
  min-height: 300px;
}
p:first-child {
  margin-left: 40px;
}
#alias{
  width: 200px;
}
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 30px;
  min-height: 200px;
}
#seccionesSwitch {
  margin-top: 40px;
  margin-left: 20px;
}
th {
  min-width: 150px;
  padding: 10px;
}
th,
td {
  border: solid;
  border-color: rgb(190, 185, 185);
  text-align: center;
  height: 40px;
}
button {
  width: 220px;
  height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 40px;
}
#savebtn {
  width: 170px;
  margin-left: 15px;
}
td input {
  height: 30px;
  width: 30px;
  position: relative;
  margin: 5px auto;
  cursor: pointer;
}

#annotation {
  width: 820px;
  margin-top: 20px;
  margin-left: 16px;
}
#sections {
  width: 820px;
  margin-left: 16px;
  margin-top: 10px;
}
#annotation p,
#sections p {
  margin-left: 0;
  margin-bottom: 10px;
}
#annotation p {
  margin-bottom: 0;
  color: rgb(0, 123, 255);
  text-decoration: underline;
  font-weight: bold;
}
#annotation small {
  margin-top: 0px;
}
#firstRow{
  width: 500px;
}
#secondRow{
  margin-left: 0px;
  margin-bottom: 10px;
}
#secondNote{
  margin-left: 9px;
}
</style>
